/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { forwardRef, MouseEventHandler } from "react";

import { css, cx } from "@panda/css";

import { CosmosLink } from "../..";

import type { CosmosLinkProps } from "../..";

export interface CosmosClickableBoxLinkProps extends CosmosLinkProps {
	onMouseLeave?: MouseEventHandler<HTMLAnchorElement> | undefined;
}

const clickableBoxLinkStyles = css({
	"&::before": {
		content: "''",
		cursor: "inherit",
		display: "block",
		height: "100%",
		inset: 0,
		position: "absolute",
		width: "100%",
		zIndex: 1,
	},
});

export const CosmosClickableBoxLink = forwardRef<any, CosmosClickableBoxLinkProps>(
	({ children, className, ...props }, forwardedRef) => {
		return (
			<CosmosLink
				{...props}
				className={cx("clickable-box__link", clickableBoxLinkStyles, className)}
				ref={forwardedRef}
			>
				{children}
			</CosmosLink>
		);
	},
);

CosmosClickableBoxLink.displayName = "CosmosClickableBoxLink";
